import { _ as _root } from './_root.mjs';

var root = _root;

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

var _Uint8Array = Uint8Array;

export { _Uint8Array as _ };
